export const wallet = {
  name: "wallet" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M4.5 4.9A1.1 1.1 0 0 0 3.4 6v.1h14.2V5a.1.1 0 0 0-.1-.1h-13Zm14.9 1.2V5a1.9 1.9 0 0 0-1.9-1.9h-13A2.9 2.9 0 0 0 1.6 6v12.5a2.9 2.9 0 0 0 2.9 2.9h16a1.9 1.9 0 0 0 1.9-1.9V8a1.9 1.9 0 0 0-1.9-1.9h-1.1Zm-16 1.8v10.6a1.1 1.1 0 0 0 1.1 1.1h16a.1.1 0 0 0 .1-.1v-2.6h-3.1a3.4 3.4 0 0 1 0-6.8h3.1V8a.1.1 0 0 0-.1-.1H3.4Zm17.2 4h-3.1a1.6 1.6 0 1 0 0 3.2h3.1v-3.2Z" clip-rule="evenodd"/></svg>`,
  keywords: ["wallet"],
  category: "finance" as const,
};
